import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

/**
 * Service for displaying toast notifications
 * Wraps ngx-sonner for consistent toast usage
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  /**
   * Display a success toast
   * @param message - Message to display
   * @param duration - Duration in milliseconds (default 2000)
   */
  success(message: string, duration = 2000): void {
    toast.success(message, { duration });
  }

  /**
   * Display an error toast
   * @param message - Message to display
   * @param duration - Duration in milliseconds (default 2000)
   */
  error(message: string, duration = 2000): void {
    toast.error(message, { duration });
  }

  /**
   * Display an info toast
   * @param message - Message to display
   * @param duration - Duration in milliseconds (default 2000)
   */
  info(message: string, duration = 2000): void {
    toast.info(message, { duration });
  }

  /**
   * Display a warning toast
   * @param message - Message to display
   * @param duration - Duration in milliseconds (default 2000)
   */
  warning(message: string, duration = 2000): void {
    toast.warning(message, { duration });
  }
}
